import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useAuth } from "../../context/authContext";
import { FaEye, FaEyeSlash } from "react-icons/fa"
const API = process.env.REACT_APP_API_URL;

const SignUpForm = () => {
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const { syncAuthFromStorage } = useAuth();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validateInputs = () => {
    const { name, email, password } = form;

    if (!/^[A-Za-z ]{3,}$/.test(name)) {
      return "Name must be at least 3 letters and contain no numbers.";
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      return "Invalid email format.";
    }

    const passwordRegex = /^(?=.*\d)(?=.*[!@#$%^&*()_+\-={}\[\]:;"'<>,.?/]).{8,}$/;

    if (!passwordRegex.test(password)) {
      return "Password must be 8+ chars, include 1 number and 1 special character.";
    }

    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationError = validateInputs();
    if (validationError) {
      setMessage(validationError);
      return;
    }

    try {
      // 1. SIGN UP
      const signupRes = await fetch(`${API}/api/auth/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const signupData = await signupRes.json();

      if (!signupRes.ok) {
        toast.error(signupData.error || "Signup failed.");
        return;
      }

      // 2. AUTO LOGIN
      const loginRes = await fetch(`${API}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: form.email, password: form.password }),
      });

      const loginData = await loginRes.json();

      if (!loginRes.ok || !loginData.token) {
        toast.error("Signup succeeded but login failed.");
        return;
      }

      const token = loginData.token;

      // 3. STORE AUTH
      localStorage.setItem("token", token);
      localStorage.setItem("role", "user");
      if (loginData.user) {
        localStorage.setItem("user", JSON.stringify(loginData.user));
      }

      // 4. MERGE CART
      const guestCart = JSON.parse(localStorage.getItem("cart") || "[]");
      if (guestCart.length > 0) {
        try {
          await fetch(`${API}/api/cart/merge`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(guestCart),
          });
          localStorage.removeItem("cart");
          toast.success("Cart restored!");
        } catch (err) {
          console.error("Cart merge failed:", err);
        }
      }

      syncAuthFromStorage();
      setForm({ name: "", email: "", password: "" });
      navigate("/");
    } catch (err) {
      console.error(err);
      toast.error("Server error. Try again later.");
    }
  };

  return (
    <div className="form-container sign-up-container">
      <form onSubmit={handleSubmit}>
        <h1>User Sign Up</h1>

        {message && <p style={{ color: "red" }}>{message}</p>}

        <input
          type="text"
          name="name"
          placeholder="Name"
          value={form.name}
          onChange={handleChange}
          required
        />

        <input
          type="email"
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
        />

        <div className="password-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Password"
                    value={form.password}
                    onChange={handleChange}
                    required
                    className="password-input"
                  />
                  <span
                    className="password-toggle-icon"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>

        <button type="submit">Sign Up</button>
      </form>
    </div>
  );
};

export default SignUpForm;